import { i18n } from "../_translations/i18n";
import { API_ERROR_CODES } from "../_constants";

export const EverouErrorMapper = {
    getMessageFromCode,
};

function getMessageFromCode(code, info, data) {
    switch (code) {

        //100 CODES - GENERAL
        case 101:
            return `GENERIC ERROR ${code}: ${JSON.stringify(info)}`; 

        case 103:
            return i18n.t("errors.invalidPublicApikey");

        case 104:
            return i18n.t("errors.contentTypeNotAllowed");

        case 105:
            return i18n.t("errors.methodNotAllowed");

        case 106:
            return i18n.t("errors.notAcceptable");

        case 107:
            return i18n.t("errors.parseError");

        case 108:
            return i18n.t("errors.unsupportedMediaType");
        
        case 109:
            return i18n.t("errors.invalidPassword");

        case 110:
            return i18n.t("errors.invalidtimezone");

        case 111:
            return i18n.t("errors.invalidApiVersion");
        
        case 112:
            return i18n.t("errors.doNotHavePermission");

        case 113:
            return i18n.t("errors.loginCodeExpiredOrMaximumAttempos");

        case 114:
            return i18n.t("error_114_data_already_exists");

        // 200 CODES - DOES NOT EXIST
        case 201:
            return i18n.t("errors.locationDoesNotExist");

        case 202:
            return i18n.t("error_202_invalid_room");

        case 203:
            return i18n.t("errors.deviceDoesNotExist");

        case 204:
            return i18n.t("errors.brainDoesNotExist");

        case API_ERROR_CODES._205_USER_NOT_EXIST:
            return i18n.t("login.usernameOrPasswordIsIncorrectErr");

        case 206:
            return i18n.t("triggers.triggerDoesNotExistErr");

        case 207:
            return i18n.t("errors.invitationDoesNotExist");

        case 208:
            return i18n.t("errors.activeBrainVideoDoesNotExist");

        case 209:
            return i18n.t("errors.mobileDoesNotExist");

        case 210:
            return i18n.t("errors.deviceVersionDoesNotExist");

        case 211:
            return i18n.t("errors.securityZoneDoesNotExist");

        case 212:
            return i18n.t("errors.pushUidDoesNotExist");

        case 213:
            return i18n.t("errors.widgetGroupDoesNotExist");

        case 214:
            return i18n.t("errors.widgetDoesNotExist");
        
        case 215:
            return i18n.t("error_215_invalid_subscription");

        case 216:
            return i18n.t("errors.cannotModifySuperguestInvitations");

        case 217:
            return i18n.t("errors.cannotCreateInvitationsForSmallPeriod");

        case 218:
            return i18n.t("errors.positionNotConfigured");

        case 219:
            return i18n.t("error_219_device_already_validated");

        case 220:
            return i18n.t("error_220_device_kit_not_exist");

        case 221:
            return i18n.t("error_221_payment_method_not_exist");

        case 222:
            return i18n.t("error_222_nfc_card_does_not_exist");
            
        case 223:
            return i18n.t("error_223_developer_account_does_not_exist");
            
        case 224:
            return i18n.t("error_224_developer_accounttoken_does_not_exist");

        // 500 CODES - OTHERS
        case 501:
            return i18n.t("errors.emailAlreadyExists");

        case 503:
            return i18n.t("errors.cannotRemoveRoomWithDevices");

        case 507:
            return i18n.t("errors.incorrectParametersForDeviceType");

        case 508:
            return i18n.t("errors.fileTooLarge");

        case 509:
            return i18n.t("errors.emailAlreadyChecked");

        case 510:
            return i18n.t("errors.invalidLogTypes");

        case 511:
            return i18n.t("errors.duplicateApikeyErr");

        case 512:
            return i18n.t("errors.ownerPermissionRequired");

        case 513:
            return i18n.t("errors.incorrectBluetoothKey");  

        case 514:
            return i18n.t("errors.noFileSupplied");

        case 515:
            return i18n.t("errors.duplicateRoomName");

        case 516:
            return i18n.t("errors.streamUsageExceeded");

        case 517:
            return i18n.t("errors.cannotUpdateDeviceLocationWithoutLinking");

        case 518:
            return i18n.t("errors.deviceTypeUpdateNotAllowed");

        case 519:
            return i18n.t("errors.deviceActionNotAllowed");

        case 520:
            return i18n.t("errors.triggerRestrictionError");

        case 521:
            return i18n.t("errors.devicesPerLocationLimitReached");

        case 522:
            return i18n.t("errors.noActiveBrainAvailable");

        case 523:
            return i18n.t("errors.duplicateOwnerName");

        case 524:
            return i18n.t("errors.brainAlreadyUpdated");

        case 525:
            return i18n.t("errors.deviceAlreadyLinkedInOtherLocation");
            
        case 526:
            return i18n.t("errors.cannotDeleteLastOwnerLocation");

        case 528:
            return i18n.t("errors.buttonTypeNotAllowed");

        case 529:
            return i18n.t("errors.beaconNotAllowed");

        case 530:
            return i18n.t("error_530_you_already_have_an_invitation");

        case 531:
            return i18n.t("errors.passwordTooSimple");

        case 532:
            return i18n.t("errors.cannotRemoveUserWithLocations");

        case 533:
            return i18n.t("errors.triggerLimitReached");

        case 534:
            return i18n.t("errors.deviceRemoteDisabled");

        case 535:
            return i18n.t("errors.emailNotChecked");

        case 536:
            return i18n.t("errors.invitationTransferLocationAlreadyExists");

        case 537:
            return i18n.t("errors.videoRecordingLimitReached");

        case 538:
            return i18n.t("errors.videoViewsLimitReached");

        case 539:
            return i18n.t("errors.anotherTriggerWithSameDeviceExists");

        case 540:
            return i18n.t("errors.triggerCausesCycle");

        case 541:
            return i18n.t("errors.deviceTypeCannotBeInhibition");

        case 542:
            return i18n.t("errors.deviceNotInBrainLocation");

        case 543:
            return i18n.t("errors.kitUidCannotBeEmpty");

        case 544:
            return i18n.t("errors.kitBrainUidCannotBeEmpty");

        case 546:
            return i18n.t("errors.deviceVersionNotCompatibleWithKit");

        case 547:
            return i18n.t("errors.deviceNotSold");

        case 548:
            return i18n.t("errors.locationHasDevices");

        case 550:
            return i18n.t("errors.triggerCannotBeEdited");

        case 551:
            return i18n.t("errors.deviceValidatorInDifferentLocation");

        case 552:   
            return i18n.t("errors.deviceValidatorIncorrectType");

        case 553:   
            return i18n.t("errors.onlySuperusersCanAcceptInvitation");

        case 554:   
            return i18n.t("errors.invitationHasNoEmail");

        case 555:   
            return i18n.t("errors.invitationStateIsNotRequested");

        case 556:   
            return i18n.t("errors.maximumUsesReachedByGarageDoor");

        case 557:   
            return i18n.t("errors.subscriptionNotActivated");

        case 558:
            return i18n.t("errors.subscriptionCancelled");

        case 559:
            return i18n.t("errors.subscriptionExpired");

        case 560:
            return i18n.t("errors.incorrectParametersForSubscriptionInformation");

        case 561:
            return i18n.t("errors.onlySATCanAcceptInvitation");

        case 562:
            return i18n.t("subscriptions.subscriptionForDeviceExistsErr");

        case 563:
            return i18n.t("errors.unableToActivateSubsInDifferentLocation");   


        case 564:
            return i18n.t("errors.notAllowedIfNotAdmin");   

        case 565:
            return i18n.t("errors.subinvitationsExceeded");

        case 566:
            return i18n.t("errors.emailsAlreadyInvited");


        case 567:
            return i18n.t("reservations.roomAlreadyConfiguredErr");

        case 568:
            return i18n.t("reservations.limitMinutesSmallerThanBlockErr");

        case 569:
            return i18n.t("errors.beginAfterThanEndErr");

        case 570:
            return i18n.t("reservations.blockMinutesBiggerTanConfigurationHoursErr");

        case 571:
            return i18n.t("reservations.limitMinutesBiggerThanConfigurationHoursErr");

        case 572:
            return i18n.t("reservations.reservationMustHaveAWeekDay");

        case 573:
            return i18n.t("errors.reservationNotComplyWithSchedule");

        case 574:
            return i18n.t("errors.unusedReservation");

        case 575:
            return i18n.t("errors.reservationDayNotAllowedErr");

        case 576:
            return i18n.t("errors.reservationDoesNotRespectBlockSize");

        case 577:
            return i18n.t("errors.reservationExceedsTimeLimit");

        case 578:
            return i18n.t("errors.reservationOverlapErr");
    
        case 579:
            return i18n.t("errors.reservationAnticipationTooLargeErr");

        case 580:
            return i18n.t("errors.reservationDoesNotExist");
        
        case 582:
            return i18n.t("error_582_already_inside_barriers");

        case 583:
            return i18n.t("error_583_already_outside_barriers");  

        case 584:
            return i18n.t("errors.reservationDoesNotMeetSlotTime");     

        case 585:
            return i18n.t("errors.alreadyHaveReservationInOtherRoomForThisTimeSlot");

        case 587:
            return i18n.t("error_587_subinvitations_without_count");

        case 588:
            return i18n.t("error_588_count_without_subinvitations_enabled");

        case 589:
            return i18n.t("error_589_invalid_invitation_group");

        case 590:
            return i18n.t("error_590_invalid_card");

        case 591:
            return i18n.t("error_591_used_card");

        case 592:
            return i18n.t("error_592_card_incompatible_with_group");

        case 593:
            return i18n.t("error_593_card_not_configured");

        case 594:
            return i18n.t("error_594_cannot_edit_device_room");

        case 595:
            return i18n.t("error_595_invalid_credentials_for_card");

        case 597:
            return i18n.t("error_597_invalid_login_code");
            
        case 598:
            return i18n.t("error_598_creating_trigger_without_brain");

        case 599:
            return i18n.t("error_599_invitations_with_subinvitations_cannot_have_duration");

        case 600:
            return i18n.t("error_600_begin_greater_than_end");

        case 601:
            return i18n.t("error_601_ble_version_not_available");

        case 602:
            return i18n.t("error_602_cannot_change_subinvitation_permission");

        case 603:
            return i18n.t("error_603_wrong_code");
        
        case 604:
            return i18n.t("error_604_user_without_locations");

        case 605:
            return i18n.t("error_605_recurrent_user_out_of_allowed_timeframe");

        case 606:
            return i18n.t("error_606_subscription_already_used_as_extension");
            
        case 607:
            return i18n.t("error_607_no_permission_edit_card_config");

        case 608:
            return i18n.t("error_608_reservation_config_time_wrong");

        case 609:
            return i18n.t("error_609_reservation_config_begin_end_required_if_not_all_day");

        case 611:
            return i18n.t("error_611_device_kit_preconfigured");

        case 612:
            return i18n.t("error_612_reservation_day_excluded");

        case 613:
            return i18n.t("error_613_subscription_transfer_to_different_device_type_disallowed");

        case 614:
            return i18n.t("error_614_clockin_does_not_exist");

        case 615:
            return i18n.t("error_615_clockin_modification_to_another_day_forbidden");
      
        case 616:
            return i18n.t("error_616_clockins_no_reset_time_configured");
  
        case 617:
            return i18n.t("error_617_subscription_activation_requires_uid");

        case 618:
            return i18n.t("error_618_subscription_only_accepts_locations");
   
        case 619:
            return i18n.t("error_619_subscription_only_accepts_devices");

        case 620:
            return i18n.t("error_620_another_clockin_same_time_exists");

        case 621:
            return i18n.t("error_621_invalid_or_expired_registration_code");

        case 622:
            return i18n.t("error_622_account_email_not_verified");
        
        case 623:
            return i18n.t("error_623_someone_with_invitation");

        case 624:
            return i18n.t("error_624_error_processing_payment");

        case 625:
            return i18n.t("error_625_automatic_payment_already_enabled");
        
        case 626:
            return i18n.t("error_626_user_has_no_authorized_payment_method");

        case 627:
            return i18n.t("error_627_error_cancelling_subscription");

        case 628:
            return i18n.t("error_628_location_has_active_subscriptions");

        case 629:
            return i18n.t("error_629_room_type_missing_rooms");

        case 630:
            return i18n.t("error_630_admin_invitation_cannot_have_subinvitations");
            
        case 631:
            return i18n.t("error_631_not_allowed_to_customize_location");

        case 632:
            return i18n.t("error_632_not_allowed_to_customize_room");

        case 633:
            return i18n.t("error_633_no_customization_for_subdomain");
    
        case 634:
            return i18n.t("error_634_error_retrieving_payment_methods");
    
        case 635:
            return i18n.t("error_635_no_configured_payment_method");

        case 636:
            return i18n.t("error_636_max_payment_methods_reached");

        case 637:
            return i18n.t("error_637_error_creating_intent");

        case 638:
            return i18n.t("error_638_invalid_intent_id");

        case 639:
            return i18n.t("error_639_incorrect_ble_packet");

        case 640:
            return i18n.t("error_640_incorrect_ble_origin_key");

        case 641:
            return i18n.t("error_641_future_clockins_not_allowed");

        case 642:
            return i18n.t("error_642_max_invitations_reached");
        
        case 643:
            return i18n.t("error_643_not_allowed_create_invitation");

        case 644:
            return i18n.t("error_644_cannot_add_unlimited_card_to_limited_group");

        case 645:
            return i18n.t("error_645_group_duration_exceeds_card_configuration");

        case 646:
            return i18n.t("error_646_invalid_card_type_for_group");

        case 647:
            return i18n.t("error_647_cannot_clockin_remotely");

        case 648:
            return i18n.t("error_648_nfc_card_already_validated");

        case 649:
            return i18n.t("error_649_no_internet_connection");

        case 650:
            return i18n.t("error_650_order_not_exist");

        case 652:
            return i18n.t("error_652_product_not_exist");

        case 653:
            return i18n.t("error_653_cannot_generate_metered_bill");

        case 654:
            return i18n.t("error_654_cannot_get_subscription_items");

        case 655:
            return i18n.t("error_655_cannot_add_item_to_subscription");

        case 656:
            return i18n.t("error_656_cannot_add_usage_to_subscription");

        case 657:
            return i18n.t("error_657_developer_already_associated");

        case 658:
            return i18n.t("error_658_no_developer_account");
            
        case 659:
            return i18n.t("error_659_limited_time_group_with_subinvitations");

        case 660:
            return i18n.t("error_660_limited_time_group_without_duration");

        case 661:
            return i18n.t("error_661_group_has_invitations");

        case 662:
            return i18n.t("error_662_location_has_clockins");

        case 663:
            return i18n.t("error_663_unspecified_export_format");

        case 664:
            return i18n.t("error_664_maximum_range_of_download_is_12_months");

        case 665:
            return i18n.t("error_665_reservation_limit_reached");

        case 666:
            return i18n.t("error_666_clockins_made_in_invalid_minimum_time_period");

        case 667:
            return i18n.t("error_667_devices_dont_have_same_type");

        case 668:
            return i18n.t("error_668_invitation_duration_exceeds_max_allowed_by_invitation_group");

        case 696:
            return i18n.t("error_696_invalid_kross_booking_authentification_parameters");

        case 734:
            return i18n.t("error_734_avantio_invalid_apikey");

        case 738:
            return i18n.t("error_738_early_checkout_not_enabled");

        case 739:
            return i18n.t("error_739_early_checkout_requires_business_plan");

        case 740:
            return i18n.t("error_740_enable_protect_guest_requires_premium");

        case 741:
            return i18n.t("error_741_auto_protect_requires_premium");

        case 769:
            return i18n.t("error_769_location_check_requires_premium");

        case 770:
            return i18n.t("error_770_early_checkin_not_enabled");

        case 771:
            return i18n.t("error_771_early_checkin_requires_premium_plan");

        case 781:
            return i18n.t("error_781_organization_owner_removal");

        case 783:
            return i18n.t("error_783_group_has_integration");

        case 784:
            return i18n.t("error_784_avantio_accommodation_not_selectable");

        case 785:
            return i18n.t("error_785_avantio_unexpected_response");

        case 786:
            return i18n.t("error_786_hostify_listing_not_selectable");

        case 787:
            return i18n.t("error_787_property_already_linked");

        case 790:
            return i18n.t("error_790_organization_template_foreign_location");

        case 791:
            return i18n.t("error_791_integration_template_company_mismatch");

        case 792:
            return i18n.t("error_792_integration_template_not_movable");

        case 793:
            return i18n.t("error_793_organization_location_requires_organization_account");

        // 750 CODES - PARKING
        case 755:
            return i18n.t("error_755_parking_spot_duplicate");

        case 756:
            return i18n.t("error_756_parking_spot_not_found");

        case 757:
            return i18n.t("error_757_parking_assignment_duplicate");

        case 758:
            return i18n.t("error_758_parking_assignment_limit_reached");

        case 759:
            return i18n.t("error_759_parking_max_too_low");

        case 760:
            return i18n.t("error_760_parking_forbidden");

        case 761:
            return i18n.t("error_761_parking_group_not_configured");

        case 762:
            return i18n.t("error_762_parking_group_invalid");

        case 763:
            return i18n.t("error_763_parking_group_not_found");

        case 764:
            return i18n.t("error_764_parking_not_enabled");

        case 765:
            return i18n.t("error_765_parking_holder_not_accepted");

        case 766:
            return i18n.t("error_766_parking_admin_transfer_pending");

        // ORGANIZATIONS
        case 774:
            return i18n.t("error_774_organization_members_require_location");

        case 775:
            return i18n.t("error_775_organization_location_requires_premium");

        case 776:
            return i18n.t("error_776_organization_delete_requires_owner");

        case 780:
            return i18n.t("error_780_organization_requires_owner");

        // Installers and guests get all the locations of the organization or
        // none: name the full ones so the manager knows where to make room.
        case 796:
            return i18n.t("error_796_organization_locations_invitation_limit", {
                locations: (data?.locations ?? [])
                    .map((location) => location.name)
                    .join(", "),
            });

        case 797:
            return i18n.t("error_797_organization_owner_role_change");

        case 798:
            return i18n.t("error_798_user_not_in_organization");

        case 799:
            return i18n.t("error_799_integration_multiple_groups");

        // Raised by the backend but unmapped until BAC-795: they reached the
        // user as "UNDEFINED ERROR CODE". 694, 708, 709 and 711 used to mean
        // two different errors each on the backend; since BAC-269 the second
        // meaning has its own code (803-806), which shares the generic message
        // so older and newer backends read the same.
        case 102:
            return i18n.t("error_102_invalid_apikey");

        case 115:
            return i18n.t("error_115_invalid_token");

        case 117:
            return i18n.t("error_117_incorrect_http_response_parameters");

        case 225:
            return i18n.t("error_225_developer_app_not_exist");

        case 226:
            return i18n.t("error_226_invitation_public_link_not_exists");

        case 227:
            return i18n.t("error_227_authorization_not_exist");

        case 228:
            return i18n.t("error_228_device_invalid_logs");

        case 229:
            return i18n.t("error_229_device_missing_logs");

        case 230:
            return i18n.t("error_230_device_no_validation_rules");

        case 504:
            return i18n.t("error_504_assign_climate_non_thermostat");

        case 505:
            return i18n.t("error_505_device_is_not_climate");

        case 506:
            return i18n.t("error_506_climate_different_location");

        case 527:
            return i18n.t("error_527_climate_not_associated_thermostat");

        case 545:
            return i18n.t("error_545_active_brain_without_central");

        case 581:
            return i18n.t("error_581_location_user_not_exist");

        case 586:
            return i18n.t("error_586_reservation_not_yet");

        case 596:
            return i18n.t("error_596_remote_without_brain");

        case 651:
            return i18n.t("error_651_unsupported_device");

        case 670:
            return i18n.t("error_670_cannot_delete_original_nfc_invitation");

        case 671:
            return i18n.t("error_671_cannot_delete_group_with_cards");

        case 672:
            return i18n.t("error_672_cannot_delete_location_with_cards");

        case 673:
            return i18n.t("error_673_unlimited_group_with_duration");

        case 674:
            return i18n.t("error_674_cannot_cancel_public_api_invitation");

        case 675:
            return i18n.t("error_675_room_has_invitation_groups_associated");

        case 676:
            return i18n.t("error_676_location_have_not_a_valid_subscription");

        case 677:
            return i18n.t("error_677_suscription_already_exists_in_location");

        case 678:
            return i18n.t("error_678_invitation_invalid_public_link");

        case 679:
            return i18n.t("error_679_invitation_already_has_public_link");

        case 680:
            return i18n.t("error_680_location_capacity_exceeded");

        case 682:
            return i18n.t("error_682_integration_not_exist");

        case 683:
            return i18n.t("error_683_capacity_smaller_than_parking_users");

        case 684:
            return i18n.t("error_684_invitation_time_slots_overlapping");

        case 685:
            return i18n.t("error_685_card_pack_not_exist");

        case 686:
            return i18n.t("error_686_card_pack_without_group");

        case 687:
            return i18n.t("error_687_card_pack_limited_cannot_be_disassociated");

        case 688:
            return i18n.t("error_688_location_invalid_as_parking");

        case 689:
            return i18n.t("error_689_host_already_in_group");

        case 690:
            return i18n.t("error_690_integration_company_not_valid");

        case 691:
            return i18n.t("error_691_hostify_invalid_apikey");

        case 692:
            return i18n.t("error_692_hostify_invalid_host_id");

        case 693:
            return i18n.t("error_693_hostify_delete_webhook");

        case 694:
        case 803:
            return i18n.t("error_694_hostify_not_found");

        case 695:
            return i18n.t("error_695_webhook_already_registered");

        case 697:
            return i18n.t("error_697_smoobu_invalid_apikey");

        case 698:
            return i18n.t("error_698_kross_invalid_token");

        case 699:
            return i18n.t("error_699_integration_sync_not_supported");

        case 701:
            return i18n.t("error_701_apikey_already_in_use");

        case 702:
            return i18n.t("error_702_integration_data_already_in_use");

        case 703:
            return i18n.t("error_703_tag_not_exist");

        case 704:
            return i18n.t("error_704_kross_too_many_requests");

        case 706:
            return i18n.t("error_706_reservation_after_configured_days");

        case 707:
            return i18n.t("error_707_octorate_invalid_token");

        case 708:
        case 804:
            return i18n.t("error_708_integration_invalid_apikey");

        case 709:
        case 805:
            return i18n.t("error_709_integration_invalid_data");

        case 711:
        case 806:
            return i18n.t("error_711_keypad_or_anonymous_user");

        case 712:
            return i18n.t("error_712_room_without_keypad");

        case 720:
            return i18n.t("error_720_vacation_not_exist");

        case 721:
            return i18n.t("error_721_work_shifts_overlapping");

        case 722:
            return i18n.t("error_722_clockins_invalid_work_shift");

        case 723:
            return i18n.t("error_723_integration_template_not_exist");

        case 725:
            return i18n.t("error_725_hostify_custom_field_already_exists");

        case 726:
            return i18n.t("error_726_vacation_from_work_calendar");

        case 727:
            return i18n.t("error_727_vacation_overlaps");

        case 728:
            return i18n.t("error_728_work_calendar_entry_overlaps");

        case 729:
            return i18n.t("error_729_authorization_missing_fields");

        case 730:
            return i18n.t("error_730_authorization_already_revoked");

        case 731:
            return i18n.t("error_731_authorization_already_signed");

        case 732:
            return i18n.t("error_732_authorization_revoked");

        case 733:
            return i18n.t("error_733_checkea_with_access_licenses");

        case 735:
            return i18n.t("error_735_public_device_override_not_supported");

        case 736:
            return i18n.t("error_736_add_to_home_requires_premium");

        case 737:
            return i18n.t("error_737_recommendations_requires_premium");

        case 750:
            return i18n.t("error_750_organization_not_exist");

        case 752:
            return i18n.t("error_752_user_already_in_organization");

        case 753:
            return i18n.t("error_753_location_already_in_organization");

        case 754:
            return i18n.t("error_754_not_location_admin");

        case 767:
            return i18n.t("error_767_parking_window_not_applicable");

        case 768:
            return i18n.t("error_768_login_handoff_token_invalid");

        case 772:
            return i18n.t("error_772_early_checkin_reservation_started");

        case 773:
            return i18n.t("error_773_early_checkin_already_decided");

        case 777:
            return i18n.t("error_777_location_check_requires_coordinates");

        case 778:
            return i18n.t("error_778_guest_position_required");

        case 779:
            return i18n.t("error_779_guest_out_of_range");

        case 788:
            return i18n.t("error_788_hide_link_sections_requires_premium");

        case 789:
            return i18n.t("error_789_kross_token_throttled");

        case 794:
            return i18n.t("error_794_reservations_not_enabled");

        case 795:
            return i18n.t("error_795_kross_account_expired");

        case 800:
            return i18n.t("error_800_external_service_error");

        case 801:
            return i18n.t("error_801_smoobu_clock_skew");

        case 802:
            return i18n.t("error_802_location_remove_not_owner");

        // 3000 CODES - DEVELOPERS
        case 3015:
            return i18n.t("error_3015_developer_account_disabled");

        default:
            return undefined;
    }
}
